import { showHideInputError } from "./input";

export default () => {
  Alpine.data("select", () => ({
    value: null,
    open: false,

    init() {
      const initialValue = this.$refs.input.value;

      // Ensures component state is in sync with hidden input's value, can be set programmatically.
      Object.defineProperty(this.$refs.input, "value", {
        get: () => this.value,
        set: (value) => this.value = String(value),
      });

      // Watch for value change, and update component state.
      this.$watch("value", value => {
        if (value === null) {
          return this.$refs.content.innerHTML = "";
        }

        const valueTarget = this.$refs.dropdown.querySelector(`[data-value='${value}']`);
        if (!valueTarget) {
          return this.value = null;
        }

        this.$refs.content.innerHTML = valueTarget.innerHTML;
        this.open = false;

        this.$refs.input.dispatchEvent(new Event("change"));
      });

      this.value = initialValue;
    },

    showHideInputError(e) {
      showHideInputError(e, this.$refs.container, this.$refs.error);
    }
  }));
}
